import {
  createBrowserRouter,
  createMemoryRouter,
  RouteObject,
  useNavigate,
} from 'react-router-dom';
import Layout from '@/renderer/views/Layout';
// import Login from '@/renderer/views/Login';
import DashBoard from '@/renderer/views/Layout/DashBoard';
import { ElectronSDK } from '@/electronSDK';
import { IS_IN_ELECTRON } from '@/utils/global';
import { lazy, useEffect } from 'react';
import { loginByMulerunAuth } from '../api/user';
// import Account from '@/renderer/views/Layout/Account';
// import Position from '@/renderer/views/Layout/Position';

// import CreatePosition from '@/renderer/views/Layout/Position/Create';
// import CreateInnerPosition from '@/renderer/views/Layout/Position/CreateInner';
// import DetailPosition from '@/renderer/views/Layout/Position/Detail';
// import { LoginType } from '@/types/Login';
// import { getUserInfo } from '@/renderer/api/user';
// import { lazy } from 'react';
// import { useUserStore } from '../store';

// const Knowledge = lazy(() => import('@/renderer/views/Layout/Knowledge'));
// const DetailKnowledge = lazy(
//   () => import('@/renderer/views/Layout/Knowledge/detail'),
// );
// const Question = lazy(() => import('@/renderer/views/Layout/Question'));
// const DetailQuestion = lazy(
//   () => import('@/renderer/views/Layout/Question/detail'),
// );
const Candidate = lazy(() => import('@/renderer/views/Layout/Candidates'));
const ResumeDetail = lazy(
  () => import('@/renderer/views/Layout/Candidates/detail'),
);

// const Position = lazy(() => import('@/renderer/views/Layout/Position'));
// const CreatePosition = lazy(
//   () => import('@/renderer/views/Layout/Position/Create'),
// );
// const CreateInnerPosition = lazy(
//   () => import('@/renderer/views/Layout/Position/CreateInner'),
// );
// const DetailPosition = lazy(
//   () => import('@/renderer/views/Layout/Position/Detail'),
// );

function Redirect() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/dashboard');
  }, [navigate]);
  return null;
}

export const CommonRoutes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    // id: 'layout',

    loader: async () => {
      try {
        const { searchParams } = new URL(window.location.href);
        const { userId, sessionId, agentId, time, origin, nonce, signature } =
          Object.fromEntries([...searchParams]);
        console.log({
          userId,
          sessionId,
          agentId,
          time,
          origin,
          nonce,
          signature,
        });
        if (
          userId &&
          sessionId &&
          agentId &&
          time &&
          origin &&
          nonce &&
          signature
        ) {
          console.log('TODO: 处理单点登录逻辑');
          const res = await loginByMulerunAuth({
            userId,
            sessionId,
            agentId,
            time,
            origin,
            nonce,
            signature,
          });
          // 登录成功，存储 token
          ElectronSDK.setStore('Authorization', res.data.token);
          // // 跳转dashboard
          // navigate('/dashboard');
        }
        // TODO: 获取用户信息，暂时先模拟一个用户信息
        return { isLogin: true };
        // const userInfo = await getUserInfo();
        // useUserStore.getState().setUser(userInfo.data.user_info);
        // return { isLogin: true };
      } catch (error) {
        return { isLogin: false };
      }
    },
    children: [
      {
        path: '/',
        element: <Redirect />,
      },
      {
        path: 'dashboard',
        element: <DashBoard />,
      },
      // {
      //   path: 'account',
      //   element: <Account />,
      // },
      // {
      //   path: 'position',
      //   children: [
      //     {
      //       path: '',
      //       element: <Position />,
      //     },
      //     {
      //       path: 'create',
      //       element: <CreatePosition />,
      //     },
      //     {
      //       path: 'createInner',
      //       element: <CreateInnerPosition />,
      //     },
      //     {
      //       path: 'detail/:id',
      //       element: <DetailPosition />,
      //     },
      //   ],
      // },
      {
        path: 'resume',
        children: [
          {
            path: '',
            element: <Candidate />,
          },
          {
            path: 'detail/:id',
            element: <ResumeDetail />,
          },
        ],
      },
      // {
      //   path: 'knowledge',
      //   children: [
      //     {
      //       path: '',
      //       element: <Knowledge />,
      //     },
      //     {
      //       path: 'detail/:id',
      //       element: <DetailKnowledge />,
      //     },
      //   ],
      // },
      // {
      //   path: 'question',
      //   children: [
      //     {
      //       path: '',
      //       element: <Question />,
      //     },
      //     {
      //       path: 'detail/:id',
      //       element: <DetailQuestion />,
      //     },
      //   ],
      // },
    ],
  },
  // {
  //   path: '/login',
  //   element: <Login />,
  // },
];

const router = IS_IN_ELECTRON
  ? createMemoryRouter(CommonRoutes)
  : createBrowserRouter(CommonRoutes);

window.yqGlobalRouter = {
  router,
};
export default router;
